import { IApplicationState } from '../../types/redux';

export function selectSelectedFilters(state: IApplicationState) {
  return state.vacancies.selectedFilters;
}

export function selectAllFilters(state: IApplicationState) {
  return state.vacancies.filters;
}
